var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-wrapper",style:({ 'background-color' : _vm.bgColor ? _vm.bgColor : 'rgba(0,0,0,0)',
            'color': _vm.color ? _vm.color : '#ffffff',
            'height': _vm.height ? _vm.height : '100%' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }